import { RequestInformationDataCategory } from 'generated/graphql'

export const mapStepIdToGqlCategory: Record<
  string,
  RequestInformationDataCategory
> = {
  'general-information': RequestInformationDataCategory.GeneralInformation,
  'business-activity': RequestInformationDataCategory.BusinessActivity,
  'banking-information': RequestInformationDataCategory.SettlementBankAccount,
  'beneficial-owner': RequestInformationDataCategory.BeneficialOwner,
  individuals: RequestInformationDataCategory.Individuals,
  other: RequestInformationDataCategory.Other
}
